import { REPORTJOBS, FETCH, SETTIMEZONEDATA } from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function reportJobs(blossomID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/reports?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID),
          )
          .then(function (response) {
            // console.log(response)
            dispatch(reportJobsResponseData(response))
            dispatch(apiFetching(false))
          })
          .catch(function () {
            // removed error from function
            // console.log(error)
            dispatch(apiFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching(false))
      })
  }
}

function reportJobsResponseData(response) {
  return {
    type: REPORTJOBS,
    data: response.data,
  }
}

function apiFetching(status) {
  return {
    type: FETCH,
    fetching: status,
  }
}

export function setTimezoneData(data) {
  return {
    type: SETTIMEZONEDATA,
    timezoneData: data,
  }
}
